import { ReactElement, useEffect, useState } from "react"
import { useParams } from "react-router-dom"
import { Form, Button, Upload, Select, TreeSelect } from "antd"
import { UploadFile } from "antd/lib/upload/interface"
import { UploadChangeParam } from "antd/lib/upload"
import { PlusOutlined, LoadingOutlined } from '@ant-design/icons'
import { apiPrefix } from "../../js/config"
import { axiosHandleEvent, baseAxiosNoInfo } from "../../tool/axios"

const formItemLayout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 6 }
}

type FormData = {
    id: string
    user_name: string
    phone: string
    head_pic_url: string
    in_date: string
    store_list_id: string
    belong_store_name: string
    res_item_list: {}[] | []
}

type TreeData = {
    title: string, // '产康分类1'
    value: string, // '0-0'
    key: string, // '0-0'
    children: {
        title: string, // '项目1'
        value: string, // '0-0-0'
        key: string, // '0-0-0'
    }[]
}

export default function SetFixMaster(): ReactElement {

    const { id }: { id: string } = useParams()
    const [loading, setLoading] = useState<boolean>(false)

    const [formData, setFormData] = useState<FormData>()
    const [checkedProject, setCheckedProject] = useState<string[]>()
    const [treeData, setTreeData] = useState<TreeData[]>([])

    const [formInstance] = Form.useForm()

    const onFinish = (values: any) => {
        axiosHandleEvent.post('/chankang_center/recover_list/update', {
            employee_id: id,
            head_pic_url: formInstance.getFieldValue('head_pic_url'),
            operate_item_list: formInstance.getFieldValue('operate_item_list')
        })
    }

    const uploadButton = (
        <div>
            {loading ? <LoadingOutlined /> : <PlusOutlined />}
        </div>
    )

    const handleUploadChange = (info: UploadChangeParam<UploadFile<any>>) => {
        if (info.file.status === 'uploading') {
            setLoading(true)
            return;
        }

        if (info.file.status === 'done') {
            setLoading(false)

            let data: any = { ...formData }
            data.head_pic_url = info.file.response.data[0]

            formInstance.setFieldsValue({ head_pic_url: data.head_pic_url })
            setFormData(data)
        }
    }

    const translateToTreeData = (data: { item_type_name: string, item_type_id: string, singles: [] }[]): TreeData[] => {
        return data.map(el => ({
            title: el.item_type_name, // '产康分类1'
            value: el.item_type_id, // '0-0'
            key: el.item_type_id, // '0-0'
            disabled: el.singles.length ? false : true,
            children: el.singles.map((el: { item_id: string, item_name: string }) => ({
                title: el.item_name, // '项目1'
                value: el.item_id, // '0-0-0'
                key: el.item_id, // '0-0-0'
            }))
        }))
    }

    const handleTreeSelectChange = (value: string[]) => {
        setCheckedProject(value)
    }

    useEffect(() => {
        baseAxiosNoInfo('/chankang_center/recover_list/detail', { params: { employee_id: id } }).then((res: any) => {
            if (res) {
                let formData: any = {
                    belong_store_name: res.belong_store_name,
                    user_name: res.user_name,
                    phone: res.phone,
                    head_pic_url: res.head_pic_url,
                    in_date: res.in_date,
                    operate_item_list: res.operate_item_list.map((el: any) => (el.id))
                }

                formInstance.setFieldsValue(formData)
                setFormData(res)
            }
        })

        baseAxiosNoInfo.get('/chankang_center/item_single/select_list').then((response: any) => {
            if (response) {
                response.forEach((el: { singles: any[], id: string }) => {
                    el.singles.forEach(el2 => {
                        if (el2.item_id) {
                            Object.assign(el2, { item_id: el2.item_id, standard_times: Number(el2.standard_times) })
                        }
                    })
                })

                setTreeData(translateToTreeData(response))
            }
        })
    }, [])

    return (<div className="common-level2-edit">
        {/* 产康中心 -> 产康员工管理 -> 产康师管理 -> 产康师详情 */}
        <h2>产康师详情</h2>

        <div className="clear" style={{ paddingLeft: 16, marginBottom: 16 }} >
            <Button size="small" onClick={() => { window.history.go(-1) }} >返回</Button>
        </div>

        <Form name="set_fix_master" form={formInstance} {...formItemLayout} onFinish={onFinish} >
            <Form.Item label="门店" name="belong_store_name" >{formInstance.getFieldValue('belong_store_name')}</Form.Item>
            <Form.Item label="姓名" name="user_name" >{formInstance.getFieldValue('user_name')}</Form.Item>
            <Form.Item label="手机号" name="phone" >{formInstance.getFieldValue('phone')}</Form.Item>

            <Form.Item label="个人形象照" name="head_pic_url" >
                <Upload
                    name="files"
                    data={{ fileType: 1, bucketType: 4 }}
                    action={apiPrefix + '/public/upload_file'}
                    listType="picture-card"
                    className="avatar-uploader"
                    showUploadList={false}
                    onChange={handleUploadChange}
                >
                    {formInstance.getFieldValue('head_pic_url') != '' ? <img src={formInstance.getFieldValue('head_pic_url')} alt="avatar" style={{ width: '100%' }} /> : uploadButton}
                </Upload>
            </Form.Item>

            <Form.Item label="入职时间" name="in_date" >{formInstance.getFieldValue('in_date')}</Form.Item>

            <Form.Item label="可操作项目" name="operate_item_list">
                <TreeSelect treeData={treeData} treeCheckable={true} onChange={handleTreeSelectChange} />
            </Form.Item>

            <Form.Item wrapperCol={{ offset: 3 }}>
                <Button type="primary" htmlType="submit">提交</Button>
            </Form.Item>
        </Form>
    </div>)
}